(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '../../Link', 'react-icons/fa6', 'prop-types'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('../../Link'), require('react-icons/fa6'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Link, global.fa6, global.propTypes);
    global.GroupList = mod.exports;
  }
})(this, function (exports, _react, _Link, _fa, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _Link2 = _interopRequireDefault(_Link);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var GroupList = function (_React$Component) {
    _inherits(GroupList, _React$Component);

    function GroupList(props) {
      _classCallCheck(this, GroupList);

      var _this = _possibleConstructorReturn(this, (GroupList.__proto__ || Object.getPrototypeOf(GroupList)).call(this, props));

      _this.state = {
        subMenuOpen: false,
        subGroupLinks: {},
        height: 0
      };
      return _this;
    }

    _createClass(GroupList, [{
      key: 'handleLinkGroups',
      value: function handleLinkGroups(currId) {
        var subGroupLinks = this.state.subGroupLinks;

        // Prevents more than one sub-menu from displaying
        if (!subGroupLinks[currId]) {
          subGroupLinks[currId] = { subOpen: false };
        }

        for (var i in subGroupLinks) {
          if (subGroupLinks[i] !== subGroupLinks[currId]) {
            subGroupLinks[i] = { subOpen: false };
          } else {
            if (subGroupLinks[i] === subGroupLinks[currId] && subGroupLinks[i].subOpen === true) {
              subGroupLinks[i] = { subOpen: false };
            } else {
              subGroupLinks[i] = { subOpen: true };
            }
          }
        }

        this.setState({
          subGroupLinks: subGroupLinks
        });
      }
    }, {
      key: 'buildList',
      value: function buildList(list) {
        var _this2 = this;

        var listLen = list.length;
        var setClasses = '';
        var height = '';
        var subMenuHeight = {};

        height = 42 * this.props.list.length + 'px';
        subMenuHeight.maxHeight = height;

        return list.map(function (link, i) {
          if (listLen === i + 1 && link.classes !== 'call-out') {
            if (link.classes) {
              setClasses = link.classes + ' group-list-item last-menu-item';
            } else {
              setClasses = 'group-list-item last-menu-item';
            }
          } else {
            if (link.classes) {
              setClasses = link.classes + ' group-list-item';
            } else {
              setClasses = 'group-list-item one';
            }
          }

          return _react2.default.createElement(
            'li',
            {
              key: i,
              className: setClasses,
              style: {
                // margin: link.classes === 'call-out' ? '20px 0' : '0',
                padding: '0',
                fontWeight: '300',
                textTransform: !_this2.props.isMobile && link.classes === 'call-out' ? 'uppercase' : 'none',
                color: link.classes === 'call-out' ? '#f0ab00' : '#fff',
                textAlign: _this2.props.isMobile ? 'left' : '',
                borderBottom: link.classes === 'call-out' && _this2.props.isMobile ? '3px solid #222' : 'none'
              }
            },
            _react2.default.createElement(
              _Link2.default,
              {
                href: link.classes === 'sub-menu' ? '' : link.src ? link.src : '',
                style: {
                  color: 'inherit',
                  fontSize: '14px',
                  textDecoration: link.classes === 'sub-menu' || link.classes === 'call-out' ? 'none' : 'underline',
                  transition: 'background-color 0.2s color 0.2s ease-in-out',
                  padding: _this2.props.isMobile ? '5px 10px' : '10px 10px 10px 15px',
                  display: 'block',
                  cursor: 'pointer',
                  margin: _this2.props.isMobile && link.classes === 'call-out' ? '30px 0' : '',
                  borderBottom: link.classes === 'call-out' && _this2.props.isMobile ? '3px solid red' : 'none'
                },
                hoverStyles: {
                  color: _this2.props.isMobile ? '#fff' : link.classes === 'call-out' ? '#000' : '#fff',
                  backgroundColor: link.classes === 'call-out' ? '#f0ab00' : '#555555',
                  fontWeight: '400'
                },
                list: link.subMenu ? link.subMenu : null,
                isMobile: _this2.props.isMobile,
                isSubGroupLink: true,
                handleLinkGroups: _this2.handleLinkGroups.bind(_this2),
                subLinks: _this2.state.subGroupLinks,
                height: _this2.state.height
              },
              link.text,
              !_this2.props.isMobile && link.classes === 'sub-menu' ? _react2.default.createElement(_fa.FaAngleRight, { size: 20, style: {
                  float: 'right'
                }, className: 'fa-angle-right menu-arrow' }) : ''
            )
          );
        });
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.getHeight();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.getHeight();
      }
    }, {
      key: 'getHeight',
      value: function getHeight() {
        if (this.state.height !== this.div.clientHeight) {
          this.setState({ height: this.div.clientHeight });
        }
      }
    }, {
      key: 'createListStyles',
      value: function createListStyles() {
        var _this3 = this;

        // let height = this.props.listOpen ? (42 * this.props.list.length) + 'px' : '0';
        var height = '';

        if (this.props.isMobile && this.props.listOpen) {
          // Height is higher to account for the sub-menu items
          // TODO: Get exact exact height from design. There is a delay with closing the menu
          // beacuse it is detracting x amount of pixels from max height
          height = '1000px';
        } else if (this.props.listOpen) {
          height = 42 * this.props.list.length + 'px';
        } else if (!this.props.listOpen) {
          height = '0';
        }

        var listStyles = {
          overflow: this.props.isMobile ? 'hidden' : '',
          listStyle: 'none',
          background: this.props.isMobile ? 'transparent' : '#000',
          width: this.props.isMobile ? 'auto' : '200%',
          minWidth: this.props.isMobile ? 'auto' : '200px',
          position: this.props.isMobile ? 'static' : 'absolute',
          padding: !this.props.isMobile ? '0 0 40px 0' : 0,
          transition: 'all 0.25s ease-in-out',
          zIndex: '5'
        };

        if (!this.props.isMobile) {
          this.props.list.map(function (item) {
            if (item.subMenu) {
              // console.log('submenu', item.subMenu.length, 'listLength', this.props.list.length)
              if (item.subMenu.length > _this3.props.list.length) {
                height = 48 * item.subMenu.length + 'px';
                listStyles.height = height;
                // console.log(item.subMenu.length)
              }
            }
          });
        } else {
          listStyles.maxHeight = height;
        }

        return listStyles;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'ul',
            {
              className: 'link-group-list' + (this.props.isMobile ? ' text-center' : ''),
              style: this.createListStyles(),
              id: 'menu-group',
              ref: function ref(div) {
                _this4.div = div;
              }
            },
            this.buildList(this.props.list)
          )
        );
      }
    }]);

    return GroupList;
  }(_react2.default.Component);

  exports.default = GroupList;


  GroupList.propTypes = {
    list: _propTypes2.default.array,
    listOpen: _propTypes2.default.bool,
    isMobile: _propTypes2.default.bool
  };

  GroupList.defaultProps = {
    list: []
  };
});